import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Grid, MenuItem,InputLabel, Select  } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import moment from "moment";
import FormHelperText from "@material-ui/core/FormHelperText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(1, 1),
  },
  paper: {
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(1),
  },
}));

const AddOrUpdateCollectedWaste = (props) => {
  const classes = useStyles();
  const materialDetailsTypes = [
    {
      id:"1",
      name:"Recyclable"
    },
    {
      id:"2",
      name:"Non - Recyclable (Residual)"
    },
    {
      id:"3",
      name:"Reusable"
    },
    {
      id:"4",
      name:"Compost"
    },
]









  const {
    handleButtonClick,
    action,
    handleCollectionChange,
    addAnother,
    handleAddAnother,
    loading,
  } = props;

  const defaultCollectionType = { id: 0, name: "Choose a Collection Type" };
  const defaultCollectionCenter = { id: 0, name: "Choose a Collection Center" };
  const defaultWasteType = { id: 0, name: "Choose Waste Type" };
  const defaultMaterialType = { id: 0, name: "Choose Material Type" };
  const defaultUnitOfMeasure = { id: 0, name: "Choose Measure Unit" };

  let {
    collectionTypes,
    collectionCenters,
    wasteTypes,
    materialTypes,
    unitsOfMeasure,
  } = props;

  collectionTypes = [defaultCollectionType, ...collectionTypes];
  collectionCenters = [defaultCollectionCenter, ...collectionCenters];
  wasteTypes = [defaultWasteType, ...wasteTypes];
  materialTypes = [defaultMaterialType, ...materialTypes];
  unitsOfMeasure = [defaultUnitOfMeasure, ...unitsOfMeasure];

  const initialState = {
    collectedWaste: {
      datecollected: moment(),
      measureunit: process.env.REACT_APP_DEFAULT_MEASUREUNIT,
    },
    selectedCollectionType: defaultCollectionType,
    selectedCollectionCenter: defaultCollectionCenter,
    selectedWasteType: defaultWasteType,
    selectedMaterialType: defaultMaterialType,
    selectedUnitOfMeasure: defaultMaterialType,
    selectedMaterialDetail:"",
  };

  const [state, setState] = useState(initialState);

  const {
    collectedWaste,
    selectedCollectionType,
    selectedCollectionCenter,
    selectedWasteType,
    selectedMaterialType,
    selectedUnitOfMeasure,
  } = state;

  const {
    collectiontype,
    collectioncenter,
    wastetype,
    details,
    datecollected,
    materialtype,
    measureunit,
    make,
    model,
    serial_number,
    weight,
    quantity,
  } = collectedWaste;

  const isEmpty = (data) => {
    let response = true;
    if (data) {
      response = false;
    }
    return response;
  };

  const isValidData =
    !isEmpty(collectiontype) &&
    !isEmpty(collectioncenter) &&
    !isEmpty(wastetype) &&
    !isEmpty(details) &&
    !isEmpty(datecollected) &&
    !isEmpty(materialtype) &&
    !isEmpty(measureunit) &&
    !isEmpty(weight);

  const handleInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const collectedWaste = { ...state.collectedWaste, [name]: value };
    setState((prevState) => ({
      ...prevState,
      collectedWaste,
    }));
  };


  const handleDateChange = async (name, value) => {
    const collectedWaste = {
      ...state.collectedWaste,
      [name]: moment(value).format("YYYY-MM-DD HH:mm"),
    };
    setState((prevState) => ({
      ...prevState,
      collectedWaste,
    }));
  };

  useEffect(() => {
    const selectedCollectionType = collectionTypes.filter(
      (collectionType) =>
        collectionType.id == props?.collectedWaste?.collectiontype
    )[0];

    const selectedCollectionCenter = collectionCenters.filter(
      (collectionCenter) =>
        collectionCenter.id == props?.collectedWaste?.collectioncenter
    )[0];

    const selectedWasteType = wasteTypes.filter(
      (wasteType) => wasteType.id == props?.collectedWaste?.wastetype
    )[0];

    const selectedMaterialType = wasteTypes.filter(
      (materialType) => materialType.id == props?.collectedWaste?.materialtype
    )[0];

    const selectedUnitOfMeasure = unitsOfMeasure.filter(
      (unitOfMeasure) => unitOfMeasure.id == props?.collectedWaste?.measureunit
    )[0];

    setState((prevState) => ({
      ...prevState,
      collectedWaste: props?.collectedWaste,
      selectedCollectionType: selectedCollectionType ?? defaultCollectionType,
      selectedCollectionCenter:
        selectedCollectionCenter ?? defaultCollectionCenter,
      selectedWasteType: selectedWasteType ?? defaultWasteType,
      selectedMaterialType: selectedMaterialType ?? defaultMaterialType,
      selectedUnitOfMeasure: selectedUnitOfMeasure ?? defaultUnitOfMeasure,
    }));
  }, [props.collectedWaste]);

  return (
    <div>
      <Dialog
        open={!(action === "Close") && !loading}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
      >
        <DialogTitle style={{ padding: "0px" }}>
          <Grid container justify="flex-end">
            <IconButton
              onClick={() => {
                handleButtonClick(`Close`);
              }}
            >
              <CloseIcon style={{ fill: "red" }} />
            </IconButton>
          </Grid>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs>
              <Grid container spacing={2}>
                <Grid item xs>
                  <b>{action} Collection</b>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ padding: "0px" }}>
          <div className={classes.root}>
            <Paper className={classes.paper}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <FormControl error={isEmpty(collectiontype)}>
                    <Autocomplete
                      autoFocus
                      options={collectionTypes}
                      value={selectedCollectionType}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      style={{ width: 200 }}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const { collectedWaste } = state;
                          collectedWaste.collectiontype = newValue.id;
                          const selectedCollectionType = newValue;
                          setState((prevState) => ({
                            ...prevState,
                            collectedWaste,
                            selectedCollectionType,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Collection Types"
                          variant="standard"
                        />
                      )}
                    />
                    {isEmpty(collectiontype) && (
                      <FormHelperText>Required.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl error={isEmpty(collectioncenter)}>
                    <Autocomplete
                      options={collectionCenters}
                      value={selectedCollectionCenter}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      style={{ width: 200 }}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const { collectedWaste } = state;
                          collectedWaste.collectioncenter = newValue.id;
                          const selectedCollectionCenter = newValue;
                          setState((prevState) => ({
                            ...prevState,
                            collectedWaste,
                            selectedCollectionCenter,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Collection Centers"
                          variant="standard"
                        />
                      )}
                    />
                    {isEmpty(collectioncenter) && (
                      <FormHelperText>Required.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl error={isEmpty(wastetype)}>
                    <Autocomplete
                      options={wasteTypes}
                      value={selectedWasteType}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      style={{ width: 200 }}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const { collectedWaste } = state;
                          collectedWaste.wastetype = newValue.id;
                          const selectedWasteType = newValue;
                          setState((prevState) => ({
                            ...prevState,
                            collectedWaste,
                            selectedWasteType,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Waste Types"
                          variant="standard"
                        />
                      )}
                    />
                    {isEmpty(wastetype) && (
                      <FormHelperText>Required.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <FormControl error={isEmpty(materialtype)}>
                    <Autocomplete
                      options={materialTypes}
                      value={selectedMaterialType}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      style={{ width: 200 }}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const { collectedWaste } = state;
                          collectedWaste.materialtype = newValue.id;
                          const selectedMaterialType = newValue;
                          setState((prevState) => ({
                            ...prevState,
                            collectedWaste,
                            selectedMaterialType,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Material Types"
                          variant="standard"
                        />
                      )}
                    />
                    {isEmpty(materialtype) && (
                      <FormHelperText>Required.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={4}>

                  <InputLabel  style={{fontSize:"small",marginTop:"3%"}} id="choosepartner">Choose Material Detail *</InputLabel>
                  <Select
                    labelId="choosepartner"
                    error={isEmpty(details)}
                    helperText={isEmpty(details) ? "Required." : ""}
                    margin="dense"
                    name="details"
                    id="details"
                    label="Material Detail"
                    onChange={handleInput}
                    value={details ?? ""}
                    fullWidth
                    required
                  >
                    <MenuItem value="">Choose below </MenuItem>
                    {materialDetailsTypes.map((type) => (
                      <MenuItem key={type?.id} value={type?.name}>
                        {type?.name}
                      </MenuItem>
                    ))}
                  </Select>




                </Grid>
                

                <Grid item xs={4}>
                  <TextField
                    margin="dense"
                    name="make"
                    id="make"
                    label="Make"
                    type="text"
                    onChange={handleInput}
                    value={make ?? ""}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <TextField
                    margin="dense"
                    name="model"
                    id="model"
                    label="Model"
                    type="text"
                    onChange={handleInput}
                    value={model ?? ""}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    margin="dense"
                    name="serial_number"
                    id="serial_number"
                    label="Serial Number"
                    type="text"
                    onChange={handleInput}
                    value={serial_number ?? ""}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl error={isEmpty(measureunit)}>
                    <Autocomplete
                      options={unitsOfMeasure}
                      value={selectedUnitOfMeasure}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      style={{ width: 200 }}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const { collectedWaste } = state;
                          collectedWaste.measureunit = newValue.id;
                          const selectedUnitOfMeasure = newValue;
                          setState((prevState) => ({
                            ...prevState,
                            collectedWaste,
                            selectedUnitOfMeasure,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Unit Of Measure"
                          variant="standard"
                        />
                      )}
                    />
                    {isEmpty(measureunit) && (
                      <FormHelperText>Required.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <TextField
                    error={isEmpty(weight)}
                    helperText={isEmpty(weight) ? "Required." : ""}
                    margin="dense"
                    name="weight"
                    id="weight"
                    label="Weight"
                    type="number"
                    onChange={handleInput}
                    value={weight ?? 0}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    margin="dense"
                    name="quantity"
                    id="quantity"
                    label="Quantity (Number)"
                    type="number"
                    onChange={handleInput}
                    value={parseInt(quantity) ?? 0}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl error={isEmpty(datecollected)}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDateTimePicker
                        value={datecollected}
                        onChange={(Date) =>
                          handleDateChange(`datecollected`, Date)
                        }
                        label="Collection Date"
                        onError={console.info}
                        // minDate={ }
                        maxDate={moment()}
                        // format="DD/MM/YYYY hh:mm a"
                      />
                    </MuiPickersUtilsProvider>
                    {isEmpty(datecollected) && (
                      <FormHelperText>Required.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "0px" }}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs>
              {action === "Add" && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={addAnother}
                      onChange={handleAddAnother}
                      name="addAnother"
                      color="primary"
                    />
                  }
                  label="Add another"
                />
              )}
            </Grid>
            <Grid item xs>
              <Grid container spacing={2}>
                <Grid item xs>
                  <Button
                    onClick={() => {
                      handleButtonClick(`Close`);
                    }}
                    color="primary"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs>
                  {(action === "Add" || action === "Update") && (
                    <Button
                      onClick={() => {
                        handleCollectionChange(collectedWaste);
                      }}
                      color="primary"
                      variant="outlined"
                      disabled={!isValidData}
                    >
                      {action}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default AddOrUpdateCollectedWaste;
